var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgThreeDotFilled = function SvgThreeDotFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
    fill: "#2955DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
    fill: "#6695FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
    fill: "#04339D"
  })));
};
export default SvgThreeDotFilled;